import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as EmailIconSvg } from '../../assets/email-icon.svg';

export const EmailIcon = (props: Partial<CustomIconComponentProps>) => {
  return <Icon component={EmailIconSvg} {...props} />;
};
